var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b, _c, _d, _e;
// import { ChainId, NATIVE_ADDRESS, SOLANA_NATIVE_ADDRESS } from './networks';
// import { fetchEVMTokenBalances } from '../evm/base/fetchEVMTokenBalance';
// import { fetchSVMTokenBalances } from '../solana/base/fetchSVMTokenBalances';
export var TIME_PERIOD;
(function (TIME_PERIOD) {
    TIME_PERIOD[TIME_PERIOD["ONE_YEAR"] = 31536000] = "ONE_YEAR";
    TIME_PERIOD[TIME_PERIOD["ONE_DAY"] = 86400] = "ONE_DAY";
    TIME_PERIOD[TIME_PERIOD["FIVE_MINUTES"] = 300] = "FIVE_MINUTES";
    TIME_PERIOD[TIME_PERIOD["TEN_MINUTES"] = 600] = "TEN_MINUTES";
    TIME_PERIOD[TIME_PERIOD["TWO_MINUTES"] = 120] = "TWO_MINUTES";
    TIME_PERIOD[TIME_PERIOD["ONE_MINUTE"] = 60] = "ONE_MINUTE";
    TIME_PERIOD[TIME_PERIOD["ONE_HOUR"] = 3600] = "ONE_HOUR";
    TIME_PERIOD[TIME_PERIOD["THIRTY_SECONDS"] = 30] = "THIRTY_SECONDS";
})(TIME_PERIOD || (TIME_PERIOD = {}));
export var OKX_API_KEY = process.env.OKX_API_KEY;
export var OKX_PASSPHRASE = process.env.OKX_PASSPHRASE;
export var OKX_PROJECT_ID = process.env.OKX_PROJECT_ID;
export var OKX_SECRET_KEY = process.env.OKX_SECRET_KEY;
export var DEBRIDGE_ACCESS_TOKEN = process.env.DEBRIDGE_ACCESS_TOKEN;
export var SQUIDROUTER_ID = process.env.SQUIDROUTER_ID;
export var DEV_PKPS = ['0xFB183284f7b90aE2AfbD53b3C6Ff76c85F2cC0B7'];
export var ENVIRONMENT = (process.env.ENV ||
    process.env.NEXT_PUBLIC_ENV);
export var ENV_LIT_NETWORK = (process.env
    .NEXT_PUBLIC_LIT_NETWORK || process.env.LIT_NETWORK);
export var LIT_RPC_URL = process.env.LIT_RPC_URL || process.env.NEXT_PUBLIC_LIT_RPC_URL;
export var LIT_RATE_LIMIT_NFT_CONTRACT = function (overrideNetwork) {
    var networkToUse = overrideNetwork || ENV_LIT_NETWORK;
    return networkToUse == 'datil-dev'
        ? '0x1A12D5B3D6A52B3bDe0468900795D35ce994ac2b'
        : networkToUse == 'datil-test'
            ? '0xa17f11B7f828EEc97926E56D98D5AB63A0231b77'
            : networkToUse == 'datil'
                ? '0x01205d94Fee4d9F59A4aB24bf80D11d4DdAf6Eed'
                : '';
};
export var LOCAL_BASE = 'http://localhost';
export var DEV_BASE = 'https://dev-api.tradegenius.com';
export var STAGING_BASE = 'https://staging-api.tradegenius.com';
export var PROD_BASE = 'https://api.tradegenius.com';
export function getUrls(envOverride) {
    var env = envOverride || ENVIRONMENT;
    if (env === 'LOCAL') {
        return {
            EXECUTOR_URL: LOCAL_BASE + ':3101',
            QUOTER_URL: LOCAL_BASE + ':3102/quoting',
            INDEXER_URL: STAGING_BASE + '/indexer',
            //'http://localhost:3105/indexer'
        };
    }
    if (env === 'DEV') {
        return {
            EXECUTOR_URL: DEV_BASE,
            QUOTER_URL: DEV_BASE + '/quoting',
            INDEXER_URL: STAGING_BASE + '/indexer',
        };
    }
    if (env === 'STAGING') {
        return {
            EXECUTOR_URL: STAGING_BASE,
            QUOTER_URL: STAGING_BASE + '/quoting',
            INDEXER_URL: STAGING_BASE + '/indexer',
        };
    }
    if (env === 'PROD') {
        return {
            EXECUTOR_URL: PROD_BASE,
            QUOTER_URL: PROD_BASE + '/quoting',
            INDEXER_URL: STAGING_BASE + '/indexer',
        };
    }
    return {
        EXECUTOR_URL: '',
        QUOTER_URL: '',
        INDEXER_URL: '',
    };
}
export var CURRENT_VERSION = process.env.CURRENT_VERSION;
export function getControllerPrivateKey(orchestratorPKP) {
    return __awaiter(this, void 0, void 0, function () {
        var orchestratorIndex, envName, prefix, envPath, GENIUS_DEV_WALLET_PRIVATE_KEY;
        return __generator(this, function (_a) {
            orchestratorIndex = ORCHESTRATORS({ excludeFeeCollector: false }).findIndex(function (o) { return o.ethAddress === orchestratorPKP.ethAddress; });
            envName = "ORCHESTRATOR_".concat(orchestratorIndex, "_CONTROLLER_PRIVATE_KEY");
            prefix = process.env.LIT_NETWORK == 'datil-dev' ? 'DATIL_DEV_' : 'DATIL_TEST_';
            envPath = "".concat(prefix).concat(envName);
            GENIUS_DEV_WALLET_PRIVATE_KEY = process.env[envPath];
            return [2 /*return*/, GENIUS_DEV_WALLET_PRIVATE_KEY];
        });
    });
}
export function getDevWallets() {
    return {
        GENIUS_DEV_WALLET: process.env.GENIUS_DEV_WALLET_ADDRESS,
        GENIUS_DEV_WALLET_PRIVATE_KEY: process.env.GENIUS_DEV_WALLET_PRIVATE_KEY,
    };
}
export var ORCHESTRATORS = function (_a) {
    var orchestratorOverride = _a.orchestratorOverride, _b = _a.excludeFeeCollector, excludeFeeCollector = _b === void 0 ? true : _b;
    var LIT_NETWORK_IN_USE = orchestratorOverride
        ? orchestratorOverride
        : (process.env.LIT_NETWORK || process.env.NEXT_PUBLIC_LIT_NETWORK);
    if (LIT_NETWORK_IN_USE === 'datil-dev') {
        return excludeFeeCollector ? DATIL_DEV_ORCHESTRATORS.slice(1) : DATIL_DEV_ORCHESTRATORS;
    }
    else if (LIT_NETWORK_IN_USE === 'datil') {
        return excludeFeeCollector
            ? DATIL_MAINNET_STAGING_ORCHESTRATORS.slice(1)
            : DATIL_MAINNET_STAGING_ORCHESTRATORS;
    }
};
var DATIL_DEV_ORCHESTRATORS = [
    {
        tokenId: '64271672050403076989609572894434627644371069636973063095442463189238493283209',
        publicKey: '0x04fd511105853a1effef7f9d7299b1ec99e85bd611753f4cb62bd056b1dcedee2fadb68c90330d5c0b6b4057b14b986ff3906421594e2784759c5403ccd677c32d',
        ethAddress: '0x8Ba70F25BF81A2A7DB2c2026cEE43370e40Bc309',
        ciphertext: 'g0jSl0xrQqvFmrpe8Fbdw1pf3MZsMWO+UaQzdkK30ISv0n+w4dh+cgbicj4txUrOqd0Bxldo+Gt6A4rm6OLVwrpGyJbQnhp+VUgj8wjEzFTjAUoZPdHhkXbpqEVz4B2+GyM7DU22dC2XOBvAaOBOt/2Hlrb+I16x7RrIJ4KG8jQ4knKndgf2SOAGeUfpbaKfnsvGUiu9Ja1u0TDwiWLxsTZf9uTpQ7M5caY49YSk1RlzTB6eBThQ13uwo6RfAcexO6eFEA35inShrDc7m2XS+uLcEZayM6K9XPzfus6jczV/xaEl6HP/yLdgiXXydPyIVT0lXArvyL2xfw+4YJOtWU/6A6uNc9fAJEJ+kwhJMpb5I/DJ9UHA14Ql6T41UAbpiQikDfOKw3o9fAOqd5+LdQS///t4Ag==',
        dataToEncryptHash: 'aa81754cc43abd85beb793246ec479f0d6534d8de3fce6868f039a9f9ab53a42',
        solanaAddress: '5h5i8vWi7MsTJFsPzQSYER3jGyrqm8aZKVMkPennxRNu',
    },
    //@ts-ignore //we're no longer using lit, these are the centralized orchestrators
    {
        ethAddress: '0xAf3D897A4B889B9807EAFc1805F84a07618eE855',
        solanaAddress: 'FA7vpBBaTxHuLVoyvsbeLzMjDzYfZfju73tJbif6Shn8',
    },
];
var DATIL_MAINNET_STAGING_ORCHESTRATORS = [
    {
        hexTokenId: '0x851d6f495fabde01cfae20091edcbc3d23f752e81d43527af4c68c52bea46f91',
        tokenId: '60209615498448973033740783833547297483970240169033645919960513423105155428241',
        publicKey: '0x04bed79c975b616c7216a772054d370b8479f7fdbe096a2627bf306451ae6446cb308884174e9b7e0e2b40740fc148c8031fcfe70151e2b6dca01814372e38ed6b',
        // ethAddress: '0xcb1178A50a01147949c883432aee904Eb7788015',
        //replacing with the below address for fee collection that we have keys for
        ethAddress: '0x34dac76555Ab52fAB3Eb7071fB864Dbb8FA3752d',
        ciphertext: 'pCIxj/zz4Lg726HS8foO4qxqWxVYFnetwbg/VJHPL+YjicLWocZIVa87gBZWTLCwDTQ0QAxlWEQJCFTTigKEjjFRT7cZXqi6nHNqNTIrr/3lAVoq/0jRPW4PVSwF1I2rSZY25/nW88GfHD3cpcBFm90THQPTvfG0eQCWfT9GCYdBPe+p07DGimqnovg2nJewqAMVm3tVQDHWAWiWjkUGIuBorgnXJ0iPEEk6zLr8fpv92XzxSAijkGrcghM5yIRKl1TIGGA7SLAIdMNZdjYOphUY5vfMBbUgT2ujpBYAdCfHc9cgNyGKfxhkwpHLfumbXqmR3gGEd4E1Rr9E0dFmp+i9EznFdW3EIUhBPIAdnQDl7Ma2LibgFDZYvw5D9EYpFGgIJw1PYl3f9efkIe6XXLXN3y3sI8AC',
        dataToEncryptHash: 'ff3f3f2c9956b07d2b1acfb286c11aa4103763f250373076116696c5c3b33230',
        solanaAddress: '36nWszWtjg6t5qn1JSG5yk1CpLK8J8QfQPvE9aRV1gh3',
    },
    //@ts-ignore
    {
        ethAddress: '0xAf3D897A4B889B9807EAFc1805F84a07618eE855',
        solanaAddress: 'FA7vpBBaTxHuLVoyvsbeLzMjDzYfZfju73tJbif6Shn8',
    },
    //@ts-ignore
    {
        ethAddress: '0x20518BE1a498B752d467516C5A3Ad4Ff697e96fC',
        solanaAddress: '7ekgVkTgWz66qALaAr4frXv1ymM24sEDBfqeMksVWbYW',
    },
    //@ts-ignore
    {
        ethAddress: '0x362C85812f38Ad85Ad778bAdFb920D902E1c984F',
        solanaAddress: 'Goiquyrn7qyS7cn3YenfgJC8qDYp5TntoK4wAkkB6fe5',
    },
    //@ts-ignore
    {
        ethAddress: '0xa15801812370b8Ff1AB3863A59323672FF312C19',
        solanaAddress: '8Vh7mtXUwHt1iDY33X7obzfmv4LWzc2EbPgCfxWcyKnt',
    },
    //@ts-ignore
    {
        ethAddress: '0xf355AC6D016303CD396A0b4663dCD0FC7c308f97',
        solanaAddress: '5eMg2RLB3PLuaP2HeqTagb6gWUsgjK9KaaYU2toBnmQq',
    },
];
export var ETHEREUM_RPC_URL = process.env.ETHEREUM_RPC_URL;
export var AVALANCHE_RPC_URL = process.env.AVALANCHE_RPC_URL;
export var SOLANA_RPC_URL = process.env.SOLANA_RPC_URL;
export var BASE_RPC_URL = process.env.BASE_RPC_URL;
export var ARBITRUM_RPC_URL = process.env.ARBITRUM_RPC_URL;
export var OPTIMISM_RPC_URL = process.env.OPTIMISM_RPC_URL;
export var BSC_RPC_URL = process.env.BSC_RPC_URL;
export var FANTOM_RPC_URL = process.env.FANTOM_RPC_URL;
export var POLYGON_RPC_URL = process.env.POLYGON_RPC_URL;
export var BLAST_RPC_URL = process.env.BLAST_RPC_URL;
export var JITO_RPC_URL = process.env.JITO_RPC_URL;
export var JUPITER_API_ENDPOINT = process.env.JUPITER_SWAP_API;
export var JITO_TRANSACTIONS_URL = "".concat(JITO_RPC_URL, "/api/v1/transactions");
export var TENDERLY_KEY = process.env.TENDERLY_KEY;
export var TENDERLY_PROJECT = process.env.TENDERLY_PROJECT;
export var TENDERLY_USER = process.env.TENDERLY_USER;
export var TENDERLY_URL = "https://api.tenderly.co/api/v1/account/".concat(TENDERLY_USER, "/project/").concat(TENDERLY_PROJECT, "/simulate-bundle");
export var FLASHBOTS_BUNDLE_RELAY = process.env.FLASHBOTS_BUNDLE_RELAY;
export var RPCS = {
    1: process.env.ETHEREUM_RPC_URL,
    56: process.env.BSC_RPC_URL,
    137: process.env.POLYGON_RPC_URL,
    42161: process.env.ARBITRUM_RPC_URL,
    43114: process.env.AVALANCHE_RPC_URL,
    8453: process.env.BASE_RPC_URL,
    250: process.env.FANTOM_RPC_URL,
    10: process.env.OPTIMISM_RPC_URL,
    814572: process.env.BLAST_RPC_URL,
    1399811149: process.env.SOLANA_RPC_URL,
    jito: process.env.JITO_QUICKNODE_URL,
};
export var LIT_ACTION_KEYS = {
    ETHEREUM_RPC_URL: ETHEREUM_RPC_URL,
    AVALANCHE_RPC_URL: AVALANCHE_RPC_URL,
    SOLANA_RPC_URL: SOLANA_RPC_URL,
    BASE_RPC_URL: BASE_RPC_URL,
    ARBITRUM_RPC_URL: ARBITRUM_RPC_URL,
    OPTIMISM_RPC_URL: OPTIMISM_RPC_URL,
    BSC_RPC_URL: BSC_RPC_URL,
    FANTOM_RPC_URL: FANTOM_RPC_URL,
    POLYGON_RPC_URL: POLYGON_RPC_URL,
    BLAST_RPC_URL: BLAST_RPC_URL,
    JITO_RPC_URL: JITO_RPC_URL,
    JUPITER_API_ENDPOINT: JUPITER_API_ENDPOINT,
    JITO_TRANSACTIONS_URL: JITO_TRANSACTIONS_URL,
    TENDERLY_KEY: TENDERLY_KEY,
    TENDERLY_PROJECT: TENDERLY_PROJECT,
    TENDERLY_USER: TENDERLY_USER,
    TENDERLY_URL: TENDERLY_URL,
    RPCS: RPCS,
    ENVIRONMENT: ENVIRONMENT,
    FLASHBOTS_BUNDLE_RELAY: FLASHBOTS_BUNDLE_RELAY,
};
export var FEE_COLLECTION_ADDRESS = (_b = (_a = ORCHESTRATORS({ excludeFeeCollector: false })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.ethAddress;
export var SOLANA_FEE_COLLECTION_ADDRESS = (_d = (_c = ORCHESTRATORS({ excludeFeeCollector: false })) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.solanaAddress;
export var FEE_COLLECTION_ORCHESTRATOR = (_e = ORCHESTRATORS({ excludeFeeCollector: false })) === null || _e === void 0 ? void 0 : _e[0];
//does not include fee collector
export var RANDOM_ORCHESTRATOR = function () {
    var _a, _b;
    return (_a = ORCHESTRATORS({})) === null || _a === void 0 ? void 0 : _a[Math.floor(Math.random() * ((_b = ORCHESTRATORS({})) === null || _b === void 0 ? void 0 : _b.length))];
};
export var FEE_BPS = 100; // 100 basis points
export var SINGLE_CHAIN_FEE_BPS_TIERS = new Map([
    [50000, 30], // 50k or above: 20bps
    [10000, 40], // 10k or above: 30bps
    [0, 60], // Less than 10k: 50bps
]);
export var MULTI_CHAIN_FEE_BPS_TIERS = new Map([
    [50000, 30], // 50k or above: 30bps
    [10000, 40], // 10k or above: 40bps
    [0, 60], // Less than 10k: 60bps
]);
var DATIL_DEV_ORCHESTRATORS_OLD = [
    {
        tokenId: '64271672050403076989609572894434627644371069636973063095442463189238493283209',
        publicKey: '0x04fd511105853a1effef7f9d7299b1ec99e85bd611753f4cb62bd056b1dcedee2fadb68c90330d5c0b6b4057b14b986ff3906421594e2784759c5403ccd677c32d',
        // ethAddress: '0x8Ba70F25BF81A2A7DB2c2026cEE43370e40Bc309',
        //replacing with the below address for fee collection that we have keys for
        ethAddress: '0x34dac76555Ab52fAB3Eb7071fB864Dbb8FA3752d',
        ciphertext: 'g0jSl0xrQqvFmrpe8Fbdw1pf3MZsMWO+UaQzdkK30ISv0n+w4dh+cgbicj4txUrOqd0Bxldo+Gt6A4rm6OLVwrpGyJbQnhp+VUgj8wjEzFTjAUoZPdHhkXbpqEVz4B2+GyM7DU22dC2XOBvAaOBOt/2Hlrb+I16x7RrIJ4KG8jQ4knKndgf2SOAGeUfpbaKfnsvGUiu9Ja1u0TDwiWLxsTZf9uTpQ7M5caY49YSk1RlzTB6eBThQ13uwo6RfAcexO6eFEA35inShrDc7m2XS+uLcEZayM6K9XPzfus6jczV/xaEl6HP/yLdgiXXydPyIVT0lXArvyL2xfw+4YJOtWU/6A6uNc9fAJEJ+kwhJMpb5I/DJ9UHA14Ql6T41UAbpiQikDfOKw3o9fAOqd5+LdQS///t4Ag==',
        dataToEncryptHash: 'aa81754cc43abd85beb793246ec479f0d6534d8de3fce6868f039a9f9ab53a42',
        solanaAddress: '5h5i8vWi7MsTJFsPzQSYER3jGyrqm8aZKVMkPennxRNu',
    },
    {
        tokenId: '1982796056929761174255797887101857105301035067406170888131417975165776660629',
        publicKey: '0x043b798f10a8ebeb92e26bad0fe5d709b403368f22522b3f68b53e20bdc9a66ef9b851820c4b92272dc99adac322f9ae6ee11d46bc2f4fb6ee38986cd46ff36231',
        ethAddress: '0x8123268745B06abd40EC28afB346D8992345DF87',
        ciphertext: 'j6jcqtOL0CvnLdRLcwuRcHzRaM5g8z0uU4RBKF6FBcDqxmCuMqa9JA3A/5lSJBgoagPVQqUbIuN9YJqdy+OEZ2HvPVeAlVgDHL4GlNNnf4fpAYfohZ5jUFaoEw+3GeDkxeuN122Lo+jJxDa0wwdpH7lRoAjpe/GStD+3VLus+unnnoQNpd/uIVHnNfmj12YTsmn4SyLxFsmZHnTfodC/tGM8LJYwwZaVAhbwyGYi4n0cY04M0vh0I4t2Due5j2ckuXj7zMk558SF99fekAM8MYKyhXdwp7sw52aaHxho98zTPLU4Rq1sSb3idQo35DQVKMKStsaM28CzunZBJE2fkbSQvKDiPlLCnvnItsNCBmbwackTYb95TSvym0VWq1gsbIMjBX7UDrM4I60iGsGg0GRx1kbSlaYquKnQAg==',
        dataToEncryptHash: '7d77695410c68c1be1513f4f6973ba60206939278a6c14072328f5f7ed62475c',
        solanaAddress: 'F3cNzVaHEvrLwYNzWYvvQwZ7DtW6gcbFVE4Y5EiCpD7k',
    },
];
var DATIL_MAINNET_STAGING_ORCHESTRATORS_OLD = [
    {
        hexTokenId: '0x851d6f495fabde01cfae20091edcbc3d23f752e81d43527af4c68c52bea46f91',
        tokenId: '60209615498448973033740783833547297483970240169033645919960513423105155428241',
        publicKey: '0x04bed79c975b616c7216a772054d370b8479f7fdbe096a2627bf306451ae6446cb308884174e9b7e0e2b40740fc148c8031fcfe70151e2b6dca01814372e38ed6b',
        // ethAddress: '0xcb1178A50a01147949c883432aee904Eb7788015',
        //replacing with the below address for fee collection that we have keys for
        ethAddress: '0x34dac76555Ab52fAB3Eb7071fB864Dbb8FA3752d',
        ciphertext: 'pCIxj/zz4Lg726HS8foO4qxqWxVYFnetwbg/VJHPL+YjicLWocZIVa87gBZWTLCwDTQ0QAxlWEQJCFTTigKEjjFRT7cZXqi6nHNqNTIrr/3lAVoq/0jRPW4PVSwF1I2rSZY25/nW88GfHD3cpcBFm90THQPTvfG0eQCWfT9GCYdBPe+p07DGimqnovg2nJewqAMVm3tVQDHWAWiWjkUGIuBorgnXJ0iPEEk6zLr8fpv92XzxSAijkGrcghM5yIRKl1TIGGA7SLAIdMNZdjYOphUY5vfMBbUgT2ujpBYAdCfHc9cgNyGKfxhkwpHLfumbXqmR3gGEd4E1Rr9E0dFmp+i9EznFdW3EIUhBPIAdnQDl7Ma2LibgFDZYvw5D9EYpFGgIJw1PYl3f9efkIe6XXLXN3y3sI8AC',
        dataToEncryptHash: 'ff3f3f2c9956b07d2b1acfb286c11aa4103763f250373076116696c5c3b33230',
        solanaAddress: '36nWszWtjg6t5qn1JSG5yk1CpLK8J8QfQPvE9aRV1gh3',
    },
    {
        hexTokenId: '0xd891a8ba004b0ec889dd2a41df9fe4d90f39c8e723233bc893d34b4e28b041e1',
        tokenId: '97956932626345623487546040532804350360316404212175937901846047370571148181985',
        publicKey: '0x0400d0e0135f5aebad8d8a8ddc00d4b0636c668ed07d4705b2ccc940eb0d89b9792557b964fe835f23aa5b65159922d67097b6090fb6d545939ce54aa2468f0d69',
        ethAddress: '0x3349B2cB4fD9C557aA814daD9D4fD079537C35fe',
        ciphertext: 'tCQIkrM7OjKdSOsp/FaaOxnDd5KpM2Jv15DT5UWr92vvH0f7rG6k+QwYwU1RMEkxhp2zTNMaXfm3lq+5K4/+udsyUAEzMAEUPrs/S9UZyyHkAbk7RLiagPRopABeaET2lkBgTFsKsImL0kx55KvnhKT5mhHVEYbweJvkb8taWiiFCaPnbby/5RYoL41GL9pohXM3iT6+GvyizvKqu24sapTYcY4ZavfGR7dqnRL6GqTWS7bHUTUtRkGzPaJJkFXNWw8aHjwYZP5s/Z+JSSOj8y0voMPGQnRYpPxtfzLLXEj217gjFZz8Y+2/Ztqk55NwqACGUMNp0c6fCXVK+e2pFz5npl8e5joAYTe/V7zSJ8kmr/v/TuIXvs7Lsrg9U0cAAhmyRz4bWwB7WBhyHo+/cCyj1jJwzQI=',
        dataToEncryptHash: '5c1a7f8341241039f3986f63900926e77d223d351b004fcab403e17acad6ea98',
        solanaAddress: '6ZsM5qmcLrHrRxStfKtbZVhZu42rYZC1nh6HEs2fS9u1',
    },
    {
        hexTokenId: '0xe7463463119c3c036fbee9997f2a454f784cb5b4481fa20191b1f43aaa042e23',
        tokenId: '104608308878968355848493955928520790311269767537795159156255777690422140481059',
        publicKey: '0x04950ea637d1467afc51db50ecf4e972c9621c021cb0313434645a2f7927d0ba2b07b6061f20b4580494964696355523b68a56df3dc33298a67e8eb87ac5d16019',
        ethAddress: '0x56374E6114Ae03000d87D45C4724c1C23889190A',
        ciphertext: 'lcOsPVJAaaYQU2i641Tc6CZx6IGg/PwmHpMJvUg0vtTJBp5kVZLzi/uHUitULI1bKhZYw2IkBulEd8vRsAuXnRFwRknyOJQF4OOcMcNxROXqAeN3eq9G9j2v5/1zKpurqYLu2CuoXvWzkf0yKSXTXQejyT47Ikm2GnO3dCL4mBmg1RBAFmxla8Px58agcS9wvNG7KQb8QFm4vlxfPbUoUwVyOM7DTKvmj317FuWvppYjdNNAhBGtfUVb7qGUyZIwMNIo2hAS3n/mGNrUIzDDBaKDKGw351vvhxQVa0yFwTTSDBu409euao7IioYOm4ZwiMtyiTZ+iPT5r7xyWXSSIBo0a9PjykNBmSosMdNuw23KJAtZggKSEP5G1qydlzzwds994wZ2WCI1sB4apVnZcRlv788bIRJ3pgw+CwI=',
        dataToEncryptHash: 'b61190321832441e87086cc82355d14670cb6ef0b5386e9597d9949fa030102b',
        solanaAddress: 'GhfrSVekfJFthsSETABai1PYkcnihUkcfu2aEuXUwsQd',
    },
    {
        hexTokenId: '0xefa896fbd3154a7cbae422baac7bb05b4fc2c82ac9ed5b41c7b857143054f070',
        tokenId: '108400643169411719565323122803398972226596717273850552272036615454822195589232',
        publicKey: '0x0493a0756a964dc23c74c12642fd384faad0817dad0a3612123571d01245acc5236007dd505aa7233d4324e2e96cbaa52105f7b9b20beca139a40ef98231a2846d',
        ethAddress: '0x5747247fD20e3Bdfb0fB1d6199f0A2d09CbAC57C',
        ciphertext: 't1SpGftz14cZZancczhNIgaISxaXqFIg/dgyWOb9EYdw6qWxZliSKKqUa0uvhOmwuYCt8RJfQCnNmylwN0rKr8/VxFlnPWpOF9KZspDFA1zYAUBUGB+RIyFHbZ4jd03jqqgt2BXN3+cv4HFODPNcW2lxR7IT3MVPupRbFBJctfmqwxgVVLykNLM0GGmwEAgowKSsSefizK9hhSc3RjPW8kM3ER7xKUlIFEaI71vBrE78rpB9oc/2y3GFgQKVcnu8B/50y8r879Zrc45pfpdnqWP2vW66mzGB0qD8A82VcYtfFHAR4bZm65N9iMzavCCbiLZeJrBb6z44dgE99FI47OmKHeWYoOGfjsaxsKstMnadHIZVBVY+vbQ+nVWhQMeqFQBXa3VaUnimxgI=',
        dataToEncryptHash: 'ac47e0336012d2fe0f4203263b7106d22049fb47b1ddc31ab30d57381a90ce92',
        solanaAddress: 'F4mCgR6He56K8T88uupchpnaMC58jRJYhehS6SmAP9De',
    },
    {
        hexTokenId: '0x74b69aa6602484310c15cb74ead1cf4d4fef42468d7acc47cbcf7319acc022bd',
        tokenId: '52790923955862121458012768258802967507646624064637657457163077214596493222589',
        publicKey: '0x049a32917c27fae643ad9b03ebf02d14d43917652bc1ecd6d9b349df5eb533e411ede9982063dd6e2f5a8c7d9838b8755fad15daf858bfd2fc52233e65fe84bc22',
        ethAddress: '0xEeb6D55021f88BD3C94bc1A357Bf798c23481dd6',
        ciphertext: 'seFvNzWlrVyrQX5Ome34N9nh36AQJwygDJPfuXL0X3rlPNDeYlXFwcCnJYKeeGeYwh7ds0nFryArQ51uqTvNS0/aifGRtLPBxQHzL8d86F/kAbIygJUph049RdLsPCIDutwQfyP6JRa7l92MYKmv1hKxscQ3fBBOHV0ylH9M9Rcn/FpLXNxbQW11epbyb5+EIfgT4K6cKsdywn2P/Pmy5EL8KYt6i7LnsCg1PZUOkT+NWees/QtK5FGBufBVci+ADuBhPQSnobPJ4VvrXDYmfdQThP0Uzsul0xkXk3FoAaTNQdrqhcKU/s7rh5uvx7fZj0VpUJBcSEK9ozHjVdMYVTUXVSFLre7XfcAW30euaNBEhL1zp5k5SwCfVRbw1NxeAvdms4EMsOyP7L8pCxujkS1I5UGeoQI=',
        dataToEncryptHash: '6989fd3075a4ee1b40273ef9e8d2639a9c169afbc0e2071075b9152151e632ed',
        solanaAddress: '7oB6mhVEBkjRZFG8JCRCHExn6tsKHg9NACJkbb2aMdYK',
    },
    {
        hexTokenId: '0x60c68cc3bef99548031b42767088921a941ad4c91c177853f08222b527629e1b',
        tokenId: '43772840704609852115916813934232450899290738602106777818956193333496695135771',
        publicKey: '0x04dfc2a7f300a1b0c73e608902c4380d1b2314833c3a0753e5cf09b51671fd5e726180c24796dc21e426fe8fc486e07b0f736c936fd8dec956491261c292b82ed5',
        ethAddress: '0x3AFeE7F1Cd969b7305C23273dcF0A0Fe849def3c',
        ciphertext: 'uNuQgHcE3arZn9nsrjEJ9SR8bu0C7Fwt0pSoft3wyeCwBM+80h8gy/o9ktStPSIcRl8/Wa4xGSpFdKpkWx9GHgFCJCf9wBy9M9xC2s2gkGviAWpY0XS3GOB/Z6XxX0nuz1bAykwQ7loVuTgywkV/BGmBxoaOxXm5KYf1zNrBmIuKmNPn4mFQrLH/nkW0CMPTzKdQaayItenT6HM7jVLT9eulUrVf7T8zvmcnrYd6LG4XZbOKyVH3KmXiE1w40IRJC1rSUUen8hyE9V5NQGdYvV0frfKabqQ7AVCD5yKW7oEUgquskoZT5h8E3Ei3t7TQF7GH94hlfniMU275VfAcI2RDgybdb054O2l+OABo/z5gaiPGIjVcoSulqxbsDlu2xD+Dfidojb2OYdhynCVPdn3AbDkC',
        dataToEncryptHash: '4f5c0b05da74f74fb46a7e9e9708d9d275cd0ce19d36d204044152326393509e',
        solanaAddress: 'dbNr1BUF5Mski8paaMkwSoUj3GjRbNJhzSuYj69B8mF',
    },
    {
        hexTokenId: '0xea9a08fc8fb0f83eded7c91f87c7bc5aebd4a294ee89c867c0148a4c3afd983e',
        tokenId: '106113363039469999336990395940068530608958772583827173885640597776194441418814',
        publicKey: '0x04feeba6482ef5c03e3fa8d977990f643fc6b6cc5fd00da79d931beba25d30050835ee7f3e95e7e23c11f50ca88a40b6d2a2f5bca1f6c376a8888a8732ffae01e1',
        ethAddress: '0x0DB267F44B1D84d91E7a3860a080fac23E3184E5',
        ciphertext: 'lgAi0eUVrA4fdE7Rhw8y4b0vb+RO96mM9ZNWRVmTWeA5afbyKioY/f0EUCSG76HlFVtWZPhHmhMX7JMMJp9bfoiBTVvqQxr84EY4YyH1KV7jAR5fXu+Ll6NIaN7zDOlP+inWCmp3qoI7dakWRE1mI1qbwNpZPCPG9T/bj3gW/yCglCzYElpzZpnY92MC1ZT93W6wHAi9xyPL6iN9hBeUpWaw2Yox3/6PDBnE8B027Zotti9Z16iod7AaTTjO3yKCMgXXmCgHS/P2QBVMiJymkXp9vJafx7KiDj/PMr9wImz6wkwJuf8T4N/YBPG7KnuSv3yuks+16RFKi4rW1ZxOzLo/m8QrmuX5zsPOeU/GbkIetfuew/ZfuHomKMMDzjCRbpRKEnnovbxMnPx+jSju+9ogssO4Ag==',
        dataToEncryptHash: 'aeb1b58cbf4d758d9a4e60e055cc93261ecae91c88494f89bf5926b737b795de',
        solanaAddress: 'GhALw5gbotFDf5bbWn387kvn11fZCE4ev2DUrqdzmsNw',
    },
    {
        hexTokenId: '0x520efb7f495d122b5cf6ec56b6020c837c10801bd05fd641741a687538aecb0a',
        tokenId: '37116125212707096856710695279824990829871565433264498504647186419517200714506',
        publicKey: '0x042ee26d1f942ce0ced31c8a45bb46a5aca691cab6d2c96678842b62ad7d19f3e8cddf32f04939ec367982483e5319dd8f09268b81f714dd928f0875b026a87df8',
        ethAddress: '0x56e2DE39A213f57FDdaB0Eb964135116531E0D9b',
        ciphertext: 'roI546H8i2/Ae7CxlLQulGHiqvY0sE236o6eucU3Nta+VM9wBkeyQ5Yu4wp+00STc8UwaylZS64uYMOai75KCkMby/7aDOg6Fh03YTlE7cTqAfbA+8x03OPJH5WZIHxhtTcQN7QackSwNqyBsbve/QEUf4MnPHEQhJjakH/9xf4dcXZdnvQ6EAnsbhd1CTLgDWZYXvJ7vAGhusmo6tmxyqpBCEufK6QmkiJ2AnnfeYqBzNc9Ip31Hphvg1OA5icvuWGaTXM2SFor4INygPz0f13XPOk4AkaJNdmHjOXkLkv/qy5TVNQ03lu+JM75Su0DmNCoGdgv+9w8TUro7KDiXDEIqFFu/DqjI3K1rEF/WDOK30edY8dJaRX1B5NreJJh033yTeoeEcbfl0oXlgr5ZZyj/iNRijO6PJH6bQI=',
        dataToEncryptHash: '77bce62dedd6df437ddced121ce1f2bfd75af750e45806a7a4f3afef8b31bfef',
        solanaAddress: '8NrVKrL8A6ybyrxASiso1bKWqqFQo1ffnWzCPooynEtT',
    },
    {
        hexTokenId: '0xcfe1ba0c2ac54b0dea27f8586349d3d4fe71be608c3f7b6f2c9838494b62aea1',
        tokenId: '94027584299155419875331088400694344132889518485420504464261172290325076684449',
        publicKey: '0x04838b983ae44a6a15a4c38d7bb67d8517e655984b311f58341fe7ca79db656057b62fb3adb43c5cf5807705cbb3262bae8ae80cd690a8b386be67b19e40300f59',
        ethAddress: '0xa4380CcBdFd9d132bA327c3075B03db0b621eFcA',
        ciphertext: 'rxOMFA6KtNm1onbeAPtLsr5dwp7/6LHJWl3EljI+7pWOqFXdBcwA84+hft+rFmndNXmFxuZWq8CeVJoD53k/BHnHJjEVkTMvQh92M1w53BXhASFKWBpchXTIgytfHOCYCfh6yxp2buEznhicHwGhEpcC3eEstd2tapaiV72AWP0Rd+GcSZNkWl1ysJo6+uSaXjNdOq3VjNYyWkfQewayK/W6ZHxcua8BAkAa+/xX/Thvzn5O+AXbybOTdztHCZqr1MJsgJZrGlPOWc9gzm4F4aiAIP4MEJMw+K4+NDD776cgNVTxCkMQ1hmvRwJPQM6O/GCOfUjg79hNblHtoTDyKy0gsJqQUYIt63PaVlox2HVBra5TKBqfPSO5XizPFSbyXDKg27MaVPxs4ryJ0voQpuhSDAI=',
        dataToEncryptHash: '3d52e0c8a61258d9c104c626d3e72f135fe9bbf1e109c6ca94bed1579359c80e',
        solanaAddress: '3VQeBjHwg6eDqB4JQfSoxPTzZJr2zHZSVLAnYKMfZngd',
    },
    {
        hexTokenId: '0x6035f4494448bc4468df4c495e34f388eb19fdef91fb98bd9f2cac277e5942c8',
        tokenId: '43517362359802708702128242616408105038000100643875738169576437778049513636552',
        publicKey: '0x04b70d0a250c8953d41bbff617ecdd4e2f7c58d2e4ed6a710caa398f1727cb1f8c6c5343e8ea04626bb8d838f4350535841981f179d2689b3cfeacaf0efc1825a4',
        ethAddress: '0x51bD6A03257997E7abdf0C8A5aF7d31f60db112e',
        ciphertext: 'kctez6iFV1kZ7u2eyyC08las1l5hVfQ5axADG7ilPuxBiSVqBn40HSU8H5p/MgMov/5hJVIDMcKL6s9j5q7hhTbSFgijF9ll6fXfufUJbGzhAU7gifDmtvcJg9qzca88R9pn7pDk3r1HLr4KBbgmQi5oUBT1JAF5SIoMYRp6RsKpZ64upHyW3fXT4L8++NooROVPX/SqWh48mJjQdGNjVDP6vAmGVQEeN+n0G5ZvYE5yEgcn5baZ+T0csdKcxTtpeqz81+l1jfisKaAql1oPRCUkp1/Cfr8iRUPw3mnVPpmXoDcT3YjFug0E/BxylQRYBQLNoTn9K9XifmxXCt/zz8hoSrmzsw7Fu9pMl04kz8URMC3b/00ibkVsNN3tUk64Mkzc3EclIbZjRuKMswqfc0NwiAI=',
        dataToEncryptHash: '536d8f814b2472f125ca912112b5a385672d05420144fdda20d94d242e64ab2d',
        solanaAddress: 'BxcMFEtAxVDoTAzQrUJLVHr9MJ31YMmh5KWvho7x5KX8',
    },
];
